import { EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup } from '@angular/forms';
var SelectComponent = /** @class */ (function () {
    function SelectComponent() {
        this.propagateChange = function () { };
        this.options = [];
        this.isRequired = false;
        this.onModelChange = new EventEmitter();
    }
    SelectComponent.prototype._initializeValues = function () {
        if (!this.val) {
            if (!this.placeholder && this.options.length > 0)
                this.val = this.options[0].value;
        }
    };
    SelectComponent.prototype.ngOnInit = function () { };
    SelectComponent.prototype.ngOnChanges = function (changes) { };
    Object.defineProperty(SelectComponent.prototype, "val", {
        get: function () {
            return this._val;
        },
        set: function (val) {
            this._val = val;
            this.propagateChange(this._val);
            this.onModelChange.emit(this._val);
        },
        enumerable: true,
        configurable: true
    });
    SelectComponent.prototype.modelChange = function ($event) {
        this.onModelChange.emit(this._val);
    };
    // Called when form is initialized, with form model's initial value
    SelectComponent.prototype.writeValue = function (value) {
        if (value)
            this.val = value;
        this._initializeValues();
    };
    // Access to a function that informs the outside world about changes
    SelectComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    // Callback whenever a form input is touched (ex: on blur, fires touch event)
    SelectComponent.prototype.registerOnTouched = function (event) {
    };
    SelectComponent.prototype.byValue = function (item1, item2) {
        return item1 === item2;
    };
    SelectComponent.prototype.trackBy = function (index, elem) {
        return elem.value;
    };
    return SelectComponent;
}());
export { SelectComponent };
var SelectOption = /** @class */ (function () {
    function SelectOption(text, value, key) {
        this.disabled = false;
        this.text = text;
        this.value = value;
        this.key = key;
    }
    return SelectOption;
}());
export { SelectOption };
